import { Component, OnInit, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';
import { DatepickerOptions } from 'ng2-datepicker';
import { DashboardService } from '../../services/dashboard.service';
import * as moment from 'moment';
import { GlobalService } from '../../services/global.service';
import { DataTransferService } from '../../services/DataTransferService';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit, AfterViewChecked {
  //  dateOptions: DatepickerOptions = {
  //   format: 'YYYY-MM-DD',
  //   formatTitle: 'MMMM YYYY',
  //   formatDays: 'dd',
  //  };
 @ViewChild('celender') celender: ElementRef;

 date: Date = new Date();
  branchCurrencyCode: string = JSON.parse(sessionStorage.getItem('company')).BranchCurrencyCode;
  card1options: any = { icon: '../assets/img/dashboard1.svg', title: 'Shipments', slogen: 'Shipments you are going to receive from the courier', count: '0', type: 'Shipments' }
  card2options: any = { icon: '../assets/img/dashboard2.svg', title: 'Money Collection', slogen: 'The amount of money you are going to provide the courier with ', count: '0', type: this.branchCurrencyCode }
  card3options: any = { icon: '../assets/img/dashboard3.svg', title: 'Return Shipments', slogen: 'The number of shipments you are going to return with courier', count: '0', type: 'Shipments' }
  table1: any = { title: "List of new shipments", type: "new", date: this.convertoToDate(this.date), icon: '../assets/img/dashboard1.svg' };
  table2: any = { title: "List of returned shipments", type: "returned", date: this.convertoToDate(this.date), icon: '../assets/img/dashboard3.svg' };
  isSpotter: boolean = false;
  marginTop = '44'
  showConfirmCode: boolean = true
  constructor(private dashboardService: DashboardService, private globalService: GlobalService,private data: DataTransferService, private elem: ElementRef) {

  }
  modelChanged($event) {
    if (moment($event.getDate()).isBefore(new Date().getDate())) {
      this.card1options.slogen = "Received shipments";
      this.card2options.slogen = "Collected total amount";
      this.card3options.slogen = "Returned shipments";
      this.marginTop = '20'
      this.table1 = { title: "List of received shipments", type: "new", date: this.convertoToDate($event) };
      this.table2 = { title: "List of returned shipments", type: "returned", date: this.convertoToDate($event) };
      this.showConfirmCode = false
    }
    else {
      this.table1.title = "List of new shipments";
      this.card1options.slogen = "Shipments you are going to receive from the courier";
      this.card2options.slogen = "The amount of money you are going to provide the courier with";
      this.card3options.slogen = "The number of shipments you are going to return with courier";
      this.table1 = { title: "List of new shipments", type: "new", date: this.convertoToDate($event) };
      this.table2 = { title: "List of returned shipments", type: "returned", date: this.convertoToDate($event) };
      this.showConfirmCode = true

    }
    this.getSummary(this.convertoToDate($event));
    //this.table1 = { title: "List of new shipments", type: "new", date: this.convertoToDate($event) };
    //this.table2 = { title: "List of returned shipments", type: "returned", date: this.convertoToDate($event) };
  }
  convertoToDate(date) {
    if (date)
      return moment(date).format('YYYY-MM-DD');
    return '-';
  }

  ngAfterViewChecked() {
    if (JSON.parse(sessionStorage.getItem('user')) == undefined) {
      this.data.currentUser.subscribe(() => {
        try {
          this.isSpotter = JSON.parse(sessionStorage.getItem('user')).Network.NetworkId != 1;
          if (this.isSpotter) {
          
            var date = this.convertoToDate(this.date)
            this.globalService.itemValue.subscribe((nextValue) => {
              this.getSummary(date);
              this.table1 = { title: "List of new shipments", type: "new", date: this.convertoToDate(this.date), icon: '../assets/img/dashboard1.svg' };
              this.table2 = { title: "List of returned shipments", type: "returned", date: this.convertoToDate(this.date), icon: '../assets/img/dashboard3.svg' };
            })

          }
        }
        catch (e) {

        }
      })
    }
    else {
      this.isSpotter = JSON.parse(sessionStorage.getItem('user')).Network.NetworkId != 1;
      if (this.isSpotter) {
       // alert('2')
        var date = this.convertoToDate(this.date)
        this.globalService.itemValue.subscribe((nextValue) => {
          this.table1 = { title: "List of new shipments", type: "new", date: this.convertoToDate(this.date), icon: '../assets/img/dashboard1.svg' };
          this.table2 = { title: "List of returned shipments", type: "returned", date: this.convertoToDate(this.date), icon: '../assets/img/dashboard3.svg' };
        })

      }
    }
  }
  ngOnInit() {

    this.getSummary(this.convertoToDate(this.date));

  }
  openCelender(event) {
    let Elem = <HTMLElement>document.querySelector('.ngx-datepicker-input');
    Elem.click();
    
  }
  getSummary(date) {
   
 
      this.dashboardService.getSummary(date, (res) => {
        this.card1options.count = res.NewShipmentsCount
        this.card2options.count = res.MoneyCollectionAmount
        this.card3options.count = res.ReturnedShipmentsCount
      }, (err) => {


      })
    
  }

}
